<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="w1200">
            <v-breadcrumb value1="首页" value2="旅游服务" value3="天气预报"></v-breadcrumb>
        </div>

        <div class="container" id="container">
            <iframe id="weather_inc"   src="https://www.tianqi.com/lianjiangshi/?tq" width="1200" height="580" frameborder="0" marginwidth="0" marginheight="0" scrolling="no">
          
            </iframe>
            <div class="weather"></div>
            <div class="city"></div>
            <div class="cover"></div>
              <div class="incover"></div>
            <div class="list"></div>
            <!-- <div class="cover1" v-show="show"></div>
            <div class="cover2" v-show="show"></div> -->

            <!--<v-aplayer autoplay :music="music"></v-aplayer>-->
        </div>


        <v-footer></v-footer>
    </div>
</template>

<script>




    import route from '../../components/common/route1'
    import load from '../../components/common/loader'
   // import Aplayer from 'vue-aplayer'
    export default {
        name: "list1",
        data(){
            return{
                show:true,
                music:{
                    title: 'Preparation',
                    author: 'Hans Zimmer/Richard Harvey',
                    url: 'mp3/River.mp3',
                    pic: 'http://devtest.qiniudn.com/Preparation.jpg',
                    lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
                },
                bindData:[
                    {
                        name:'旅游指南',
                        url:'#/lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=40288a9d6e91c70a016e91d09edb0019&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d09edb0019'
                    },
                    {
                        name:'在线咨询',
                        url:'http://wpa.qq.com/msgrd?v=3&uin=1420561821&site=qq&menu=yes',
                        cid:'2c9a4c9b6ea63d8c016ea6474f040002'
                    },
                    {
                        name:'投诉建议',
                        url:'#/tsjy?ljcode=tsjy&columnId=40288a9d6e91c70a016e91d0f659001b&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d0f659001b'
                    }
                    ,
                    {
                        name:'旅游电话',
                        url:'#/lydh?ljcode=lydh&articleId=8a9d2ba16e01cf0d016e64426677010b&columnId=40288a9d6e91c70a016e91d12541001c&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d12541001c'
                    }
                    ,
                    {
                        name:'出游宝典',
                        url:'#/cybd?ljcode=cybd&articleId=8a9d2ba16e01cf0d016e64728b7a0115&columnId=40288a9d6e91c70a016e91d15ea2001d&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d15ea2001d'
                    }
                    ,
                    {
                        name:'常见问题',
                        url:'#/cjwt?ljcode=cjwt&articleId=8a9d2ba16ec4607c016ec59b69000005&columnId=40288a9d6e91c70a016e91d1972a001e&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d1972a001e'
                    }
                    ,
                    {
                        name:'天气预报',
                        url:'#/tqyb?ljcode=tqyb&columnId=40288a9d6e91c70a016e91d1c39a001f&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d1c39a001f'
                    }
                ]
            }
        },
        created(){
         //  this.init();
        document.getElementsByTagName('a').style.display="none"

        },
        methods:{
            init(){
                let that = this;

                var loading = this.$loading({
                    lock: true,
                    text: '加载中,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0,0.7)',
                    target:document.querySelector('#container')
                });

                this.$nextTick(()=>{
                    document.getElementById('weather_inc').onload=function(){
                         document.getElementsByClassName("cover3")[0].style.zIndex = '98';
                        loading.close();
                        // document.getElementsByClassName("incover").style.backgroundColor=red
                        
                    }
                })

            }
        },
        components:{
            "v-route":route,
            "v-load":load
        }
    }
</script>

<style lang="less" scoped>

    .container{
        position: relative;
        overflow: hidden;
    }
    #weather_inc{
        top:-90px;
        position: relative;
        z-index: 199;   
    }
    .weather{
          top:-90px;
        position: absolute;
        width: 1200px;
        height: 540px;
        background-color: #39f;
        z-index: 99;   
    }
    .list{
        position: absolute;
        top: 100px;
        margin-left: 450px;
        width: 400px;
        height: 60px;
        background-color: #39f;
        z-index: 999;
    }
    .city{
        position: absolute;
        top: 0;
        margin-left: 320px;
        width: 100px;
        height: 180px;
        background-color: #39f;
        z-index: 199;
    }
    .incover{
            width: 400px;
    height: 150px;
    background-color: #39f;
    z-index: 1000;
    position: absolute;
    top: 0;
    margin-left: 830px;
        }
.weatherbox .right .top span a {
    display: none;
}
    .cover3{
        width: 100%;
        height: 580px;
        top:-90px;
        position: absolute;
        background: rgb(250,250,250);
        z-index: 1999;
    }
    .cover{
        position: absolute;
        top:0;
        height: 90px;
        width: 100%;
        background: rgb(250,250,250);
        z-index: 1999;
    }
   
    .cover1{
        position: absolute;
        background: rgb(51,153,255);
        width: 100px;
        height: 50px;
        top:130px;
        left: 270px;
        z-index: 999;

    }
    .cover2{
       background: rgb(51,153,255);
        position: absolute;
        width: 400px;
        height: 50px;
        top:110px;
        right: 0;
        z-index: 999;
    }

    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg");
    }
    .container_box{

    }


</style>
